import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemNotification, SystemNotificationRequest } from '../models/system-notification.model';
import { DatePipe } from '@angular/common';

@Injectable()
export class SystemNotificationService {

    constructor(
        public _httpClient: HttpClient,
        public datePipe: DatePipe,
    ) {
    }

    createNotification(notification: SystemNotification): Observable<any> {
        return this._httpClient.post(`/api/systemNotifications/`, notification);
    }

    deleteNotificationByFlowAndType(flowId: string, type: string): Observable<SystemNotification> {
        return this._httpClient.delete<SystemNotification>(`/api/systemNotifications/deleteByFlowAndType/${flowId}/${type}`);
    }

    getNotifications(days?:  number): Observable<SystemNotification[]> {
        if (!days || days === 0) {
            days = 30;
        }
		let req: SystemNotificationRequest = {
			days: days
		};
		return this._httpClient.post<SystemNotification[]>("/api/systemNotifications/get-for-user", req);
    }
}
